import {Box, Divider, Flex, Image, Text} from "@mantine/core";
import ProductPlaceholderImage from '../../../../../assets/images/product_placeholder.png';


const _CartItem = ({component}) => {
    return (
        <Box
            mx={component?.customize_styles?.general_decoration?.margin_x}
            my={component?.customize_styles?.general_decoration?.margin_y}
            px={component?.customize_styles?.general_decoration?.padding_x}
            py={component?.customize_styles?.general_decoration?.padding_y}
            bg={component?.customize_styles?.general_decoration?.background_color}
            style={{
                boxShadow: `${component?.customize_styles?.general_decoration?.shadow_offset_x}px ${component?.customize_styles?.general_decoration?.shadow_offset_y}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px #00000014`,
                borderRadius: `${component?.customize_styles?.general_decoration?.border_radius}px`,
                border: `${component?.customize_styles?.general_decoration?.border_width}px solid ${component?.customize_styles?.general_decoration?.border_color}`,
            }}
        >


            <Box
                mx={component?.customize_styles?.box_decoration?.margin_x}
                my={component?.customize_styles?.box_decoration?.margin_y}
                px={component?.customize_styles?.box_decoration?.padding_x}
                py={component?.customize_styles?.box_decoration?.padding_y}
                bg={component?.customize_styles?.box_decoration?.background_color}
                style={{
                    boxShadow: `${component?.customize_styles?.box_decoration?.shadow_offset_x}px -${component?.customize_styles?.box_decoration?.shadow_offset_y}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px #00000014`,
                    borderRadius: `${component?.customize_styles?.box_decoration?.border_radius}px`,
                    border: `${component?.customize_styles?.box_decoration?.border_width}px solid ${component?.customize_styles?.box_decoration?.border_color}`,
                }}
            >
                <Flex align="center" gap={5}>
                    <Box
                        w={component?.customize_styles?.image_decoration?.width}
                        h={component?.customize_styles?.image_decoration?.height}
                        // bg={component?.customize_styles?.image_decoration?.color}
                        style={{
                            borderRadius: `${component?.customize_styles?.image_decoration?.radius}px`
                        }}
                    >
                        <Image
                            style={{ width: "100%", height: "100%" }}
                            src=""
                            fallbackSrc={ProductPlaceholderImage}
                            alt=""
                            radius={component?.customize_styles?.image_decoration?.radius}
                        />
                    </Box>
                    <Box h={88} p={8}>
                        <Text
                            w={`50%`}
                            lineClamp={1}
                            translate="yes"
                            c={component?.customize_styles?.name_text_decoration?.color}
                            fw={component?.customize_styles?.name_text_decoration?.font_weight}
                            fz={component?.customize_styles?.name_text_decoration?.font_size}
                            fs={component?.customize_styles?.name_text_decoration?.font_style}
                        >
                            Product Name
                        </Text>
                        <Box>
                            <Text
                                mt={3}
                                fz={component?.customize_styles?.product_category_text_decoration?.font_size}
                                fw={component?.customize_styles?.product_category_text_decoration?.font_weight}
                                c={component?.customize_styles?.product_category_text_decoration?.color}
                                // bg={component?.customize_styles?.product_category_text_decoration?.background_color}
                                ta={component?.customize_styles?.product_category_text_decoration?.text_align}
                            >
                                T-Shirt
                            </Text>
                        </Box>
                        <Text
                            mt={3}
                            fz={component?.customize_styles?.product_price_text_decoration?.font_size}
                            fw={component?.customize_styles?.product_price_text_decoration?.font_weight}
                            c={component?.customize_styles?.product_price_text_decoration?.color}
                            // bg={component?.customize_styles?.product_price_text_decoration?.background_color}
                            ta={component?.customize_styles?.product_price_text_decoration?.text_align}
                        >
                            $00.00
                        </Text>
                    </Box>
                </Flex>
                <Flex align="center" justify="space-between" mt={8}>
                    <Flex lign="center" justify="center">
                        <Text fz={14} c="#868E96">
                            Size:
                        </Text>
                        <Text fw={600} fz={14} c="#343A40" pl={1}>
                            XL
                        </Text>
                    </Flex>
                    <Flex align="center" gap={4}>
                        <Text fz={14} c="#868E96">
                            Size:
                        </Text>
                        <Box
                            w={15}
                            h={15}
                            bg="#E67700"
                            style={{ borderRadius: "100%" }}
                        ></Box>
                    </Flex>
                    <Flex lign="center" justify="center">
                        <Text fz={14} c="#868E96">
                            Qty:
                        </Text>
                        <Text fw={600} c="#343A40" pl={1}>
                            2{" "}
                        </Text>
                    </Flex>
                </Flex>
                <Divider my={8} />
            </Box>
        </Box>
    )
}
export default _CartItem;